<template>
	<v-content>
		<v-container fluid class="mt-12">
			<v-row justify="center">
				<v-col cols="12" sm="8" md="4">
					<v-card class="elevation-0">
						<div class="title title-container mb-10">
							<h1 class="text-center">Connexion</h1>
						</div>
					</v-card>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-col cols="12" sm="8" md="4" class="text-center">
					<v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
				</v-col>
			</v-row>
		</v-container>
	</v-content>
</template>

<script>
import axios from 'axios';

export default {
	name: 'ImpersonateProcess',
	async created() {
		try {
			const urlParams = new URLSearchParams(window.location.search);
			const token = urlParams.get('token');

			if (!token) return this.$router.push({ name: 'Login' });

			localStorage.removeItem('token');
			await this.$store.dispatch('accountManager/setToken', { token });
			axios.defaults.headers.common['x-auth-token'] = token;

			return this.$router.push({ name: 'Dashboard' });
		} catch (error) {
			console.error('Impersonate process error:', error);
			return this.$router.push({ name: 'Logout' });
		}
	},
};
</script>
